import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CoreInjectorTokens } from '@fleet-beat/core';
import { AuthService } from '@fleet-beat/shared';

@Injectable()
export class CanSelectCompanyGuard implements CanActivate {
  constructor(
    @Inject(CoreInjectorTokens.LoginUrl) private defaultUrl: string,
    private router: Router,
    private authService: AuthService,
  ) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.authenticated) {
      this.router.navigate([this.defaultUrl, 'companies']).then();
      return false;
    }
    return true;
  }
}
